module.exports = __webpack_public_path__ + "static/img/tobi.bf53361.jpg";